<!-- 活动设置 -->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <el-collapse   v-model="activeName" accordion>
      <el-collapse-item :name="1">
        <template slot="title">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-search"></i>
              <span style="margin-left: 5px;">筛选搜索</span>
            </div>
          </div>
        </template>
        <!--查询条件区域-->
        <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
          <div class="filter-container" style="margin-top: 10px">
            <el-form :inline="true" :model="queryParam" label-width="140px">
              <el-form-item label="活动名称:">
                <el-input v-model="queryParam.activityName" placeholder="活动名称"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="button-container" style="margin-top: 0px">
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
          </div>
        </el-card>
      </el-collapse-item>

    </el-collapse>


    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOne()">新增</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        v-loading="listLoading"
        ref="seleteTable"
        max-height="650"
        border>
        <el-table-column prop="activityName" label="活动名" ></el-table-column>
        <el-table-column prop="activityDetail" label="活动详情" ></el-table-column>
        <el-table-column prop="classHours" label="耗课时数量" ></el-table-column>
        <!-- <el-table-column prop="classAmount" label="耗课时金额" ></el-table-column> -->
        <el-table-column prop="startDate" label="起始时间" ></el-table-column>
        <el-table-column prop="endDate" label="结束时间" ></el-table-column>
        <el-table-column prop="numberLimit" label="人数限制" ></el-table-column>
        <el-table-column prop="teacher1" label="老师1" ></el-table-column>
        <el-table-column prop="teacher2" label="老师2" ></el-table-column>
        <el-table-column prop="teacher3" label="老师3" ></el-table-column>
        <el-table-column prop="teacher4" label="老师4" ></el-table-column>
        <el-table-column label="操作">
          <!-- <template slot-scope="scope"> -->
            <!-- <el-button @click="handleDeleteOne(scope.row)" type="danger" plain size="small">删除</el-button> -->
            <!-- <el-button @click="handleUpdateOneDlg(scope.row)" type="danger" plain size="small">修改</el-button> -->
          <!-- </template> -->
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page.sync="queryParam.pageNum"
              :page-size="queryParam.pageSize"
              :total="totalPage">
      </el-pagination>
    </div>
    <!--    添加-->
    <el-dialog
            title="新增"
            :visible.sync="visibleDlg"
            width="50%"
            center>
      <store-level-activity-detail
              :detail-param="createParam"
              :create-type=1
              @onBtnOK="onBtnOK"
              @onStoreLevelActivity="onStoreLevelActivity"
              @onBtnCancel="onBtnCancel()"
      >

      </store-level-activity-detail>
    </el-dialog>

  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {activitySetting, addStoreLevelActivity,delStoreLevelActivity} from "../../../api/ActivitySetting";
  import storeLevelActivityDetail from "./components/storeLevelActivityDetail";
  import messageUtils from "../../../utils/messageUtils";


  export default {
    components:{storeLevelActivityDetail},
    data() {
      return {
        listLoading: true,
        //查询参数
        queryParam: {
          phoneNumber:'', //家长手机号
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          //分页查询
          pageNum :1 ,//当前第几页
          pageSize : 10,
        },
        totalPage :0, //总共页数
        pageSizes:[20,50,100],
        //查询区域默认展开
        activeName:1,
        //新增任务信息
        activityInfo :{

        },
        createParam :{

        },
        //删除
        deleteParam :{
        },
        //弹窗
        visibleDlg: false,
        visibleDlgAdd:false,
        visibleDlgInfo:false,
        visibleDlgChangePasswd:false,

        //表单结果
        tableData: [
        ],
        allWorker:[],

      }
    },
    created(){
      this.fitchList()
    },
    mounted() {
      globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    },
    methods: {
      getWorker(id){
        for (let i = 0;i< this.allWorker.length;++i){
          if (this.allWorker[i].id == id){
            return this.allWorker[i].name;
          }
        }
        return ""
      },
      getStoreWorkersInfo(list){
        // console.info(list)
        this.allWorker.push({id:null,name:"无"})
        this.allWorker =this.allWorker.concat(list) ;
      },
      //点击查询按钮
      onBtnSearch() {
        this.fitchList();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.fitchList();
      },
      refreshData(list){
        this.tableData = list;
      },
      //添加一个
      handleCreateOne(){
        this.visibleDlg = true;
      },
      onBtnOK(){
        this.visibleDlg = false;
        this.fitchList();
      },
      //新增保存
      onStoreLevelActivity(data){
        data.createAdminId = globaldata.getAdminStore().id;
        data.storeFrontId =globaldata.getAdminStore().storeFrontId;
        data.phone = 0;

        addStoreLevelActivity(data).then(response =>
        {
          messageUtils.successMsg(this,response.message)
          this.visibleDlg = false;
          this.fitchList();
        })
      },
      onBtnCancel(){
        this.visibleDlg = false;
      },
      //刪除
      handleDeleteOne(row){
        console.info('删除')
        this.$confirm('是否要删除活动名为：'+ row.activityName +' 的课程?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',

        }).then(() => {
          let param = {
            id:row.id,
          }
          delStoreLevelActivity(param).then(response => {
            let data = response.data;
            if (data == true){
              messageUtils.successMsg(this,response.message);
              this.fitchList();
            }else {
              messageUtils.errorMsg(this,response.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      fitchList(){
        this.listLoading = true;
        activitySetting(this.queryParam).then(response => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.totalPage = data.total;
          data.list.forEach(item=>{
            item.teacher1 = this.getWorker(item.teacher1 )
            item.teacher2 = this.getWorker(item.teacher2 )
            item.teacher3 = this.getWorker(item.teacher3 )
            item.teacher4 = this.getWorker(item.teacher4 )
          });
          this.refreshData(data.list);
        })
      },
    }
  }



</script>






// WEBPACK FOOTER //
// src/views/my-store/activity-setting/index.vue